// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3sank","approved":"Status_approved__3CI5u","rejected":"Status_rejected__3HOn_","expired":"Status_expired__QhCRv","label":"Status_label__2cyIO"};